<div class="summary-row">
  <div class="h4">{{ 'summary.tariff.totalCosts' | translate }}</div>
  <div class="bold re-text-base lg:re-text-l">{{ totalPrice | currency: 'EUR'}}</div>
</div>
